import {
  CURP_PATTERN,
  EMAIL_PATTERN,
  INE_PATTERN,
  NUMERO_TELEFONICO_PATTERN,
  RFC_PATTERN,
  NOMBRES_PATTERN,
} from 'utils/patterns';
// import { discartNullValues } from './formatValues';

export default (value = '') => {
  let results = {};
  const names = [];
  const errors = [];
  if (value) {
    value.split(' ').forEach((item) => {
      if (NOMBRES_PATTERN.test(item)) {
        names.push(true);
      }
    });
  }
  results = {
    RFC: RFC_PATTERN.test(value),
    CURP: CURP_PATTERN.test(value),
    INE: INE_PATTERN.test(value),
    Email: EMAIL_PATTERN.test(value),
    Telefono: NUMERO_TELEFONICO_PATTERN.test(value),
  }; // TODO: Agregar validacion de Clave Ciudadana

  const moreThanOne = names.length > 1;
  const pass = Object.keys(results).map((item) => results[item]).every((item) => !item);

  if (pass && !moreThanOne) {
    errors.push('El texto no corresponde a ningún tipo de identificación');
  }
  if (!moreThanOne && pass) {
    errors.push('Se requieren al menos dos nombres');
  }
  const errorsString = errors.length > 1
    ? errors.slice(0, -1).join(', ').concat(` o ${errors.slice(-1)}`) : errors[0];

  return {
    success: !errors.length,
    results,
    errors,
    errorsString,
  };
};
